// Hook: loads the "monitored shelter" approval hold for a request's shelter —
// the shelter_notes.no_approvals flag + the admin-editable alert message
// (portal_config.monitored_shelter_alert). Returns { noApprovals, message,
// loaded }; message falls back to DEFAULT_MONITORED_SHELTER_ALERT. Read once on
// mount (keyed by shelter). See src/services/approvalHold.ts +
// docs/monitored-shelter-approval-hold-plan.md.

import React from "react";
import { getConfigValue } from "../data/portalConfig";
import { getShelterNotes } from "../data/shelterNotes";
import {
  DEFAULT_MONITORED_SHELTER_ALERT,
  MONITORED_SHELTER_ALERT_KEY,
} from "../services/approvalHold";

export interface ShelterApprovalHold {
  noApprovals: boolean;
  message: string;
  loaded: boolean;
}

export function useShelterApprovalHold(
  shelterCode?: string | null,
  shelterName?: string | null
): ShelterApprovalHold {
  const [hold, setHold] = React.useState<ShelterApprovalHold>({
    noApprovals: false,
    message: DEFAULT_MONITORED_SHELTER_ALERT,
    loaded: false,
  });

  React.useEffect(
    function () {
      const key = shelterCode || shelterName;
      if (!key) {
        setHold({ noApprovals: false, message: DEFAULT_MONITORED_SHELTER_ALERT, loaded: true });
        return;
      }
      const field = shelterCode ? "shelter_code" : "shelter_name";
      Promise.all([getShelterNotes(field, key), getConfigValue(MONITORED_SHELTER_ALERT_KEY)]).then(
        function (results) {
          const notesRow = results[0];
          const msg = results[1];
          setHold({
            noApprovals: !!notesRow?.no_approvals,
            message: typeof msg === "string" && msg ? msg : DEFAULT_MONITORED_SHELTER_ALERT,
            loaded: true,
          });
        }
      );
    },
    [shelterCode, shelterName]
  );

  return hold;
}
